export const CONSENT_TIMING_PREFIX = 'consent-bootstrap:'
const recordedMarks = new Set<string>()

/** Marks `consent-bootstrap:<name>`, once per page load. */
export function markConsentTiming(name: string): void {
  if (!import.meta.client || typeof performance.mark !== 'function') {
    return
  }

  const markName = `${CONSENT_TIMING_PREFIX}${name}`
  if (recordedMarks.has(markName)) {
    return
  }

  recordedMarks.add(markName)
  performance.mark(markName)
}

export function measureConsentTiming(
  name: string,
  startMark: string,
  endMark: string
): void {
  if (!import.meta.client || typeof performance.measure !== 'function') {
    return
  }

  const startName = `${CONSENT_TIMING_PREFIX}${startMark}`
  const endName = `${CONSENT_TIMING_PREFIX}${endMark}`
  if (
    performance.getEntriesByName(startName, 'mark').length === 0 ||
    performance.getEntriesByName(endName, 'mark').length === 0
  ) {
    return
  }

  performance.measure(`${CONSENT_TIMING_PREFIX}${name}`, startName, endName)
}

export function resetConsentTimingForTests(): void {
  recordedMarks.clear()
}
